import { validatePhoneNumber } from '../../utils';



export const validateForm = (name: string, value: string, formData: any, validationResults: any) => {
  const errors = {
    ...validationResults,
    [name]: '',
  };


  if (name === 'businessName') {
    if (!value) {
      errors.businessName = 'Business Name is required';
    }
  }

  if (name === 'email') {
    if (!value) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      errors.email = 'Email is invalid';
    }
  }

  if (name === 'createPassword') {
    if (!value) {
      errors.createPassword = 'Password is required';
    } else if (value !== formData.confirmPassword) {
      errors.createPassword = 'Passwords must match';
    } else if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(value)) {
      errors.createPassword = 'Password must be alphanumeric';
    } else {
      errors.createPassword = ''; // Clear the error message
    }
  }

  return errors;
};




export const validateInfoForm = (name: string, value: string, formData: any, validationResults: any) => {
  const errors = {
    ...validationResults,
    [name]: '',
  };
  if (name === 'firstName') {
    if (!value) {
      errors.firstName = 'First Name is required';
    }
  }
  if (name === 'lastName') {
    if (!value) {
      errors.lastName = 'Last Name is required';
    }
  }
  if (name === 'industry') {
    if (!value) {
      errors.industry = 'Industry is required';
    }
  }

  if (name === 'businessSize') {
    if (!value) {
      errors.businessSize = 'Business Size is required';
    }
  }

  if (name === 'address') {
    if (!value) {
      errors.address = 'Address is required';
    }
  }

  if (name === 'phone') {
    if (!value) {
      errors.phone = 'Phone Number is required';
    }
  }

 

  return errors;
};

